(
    function (skyward, $, undefined)
    {
        var offset = .01;
        var defaultValue = '0.00';
        var disabledValue = '';

        var defaultAllowSubjectiveSelector = "[id*='AllowSubjective']";

        // Selectors used in most Grading Scale Group Browses
        var percentLowSelector = "[id*='PercentLow']";
        var percentHighSelector = "[id*='PercentHigh']";
        var defaultCalculationPercentSelector = "[id*='DefaultCalculationPercent']";

        // Selectors used in Grading Scale Group Browses using Points
        var lowValueSelector = "[id*='ValueLow']";
        var highValueSelector = "[id*='ValueHigh']";
        var defaultCalculationValueSelector = "[id*='DefaultCalculationValue']";

        // Selectors used in Standards Grading Scale Group Browses
        var pointsLowSelector = "[id*='Low']";
        var pointsHighSelector = "[id*='High']";
        var defaultCalculationValueSelector = "[id*='DefaultCalculationValue']";
        var colorPrefix = "#Color-";

        var gradingScaleBrowses = {};

        var processGradeMarkBrowse = function (browse, isStandardsGradingScaleGroup, isPointsBasedGradingScaleGroup, isPaging)
        {
            var browseID = browse.attr('id');
            var lowSelector = isStandardsGradingScaleGroup ? pointsLowSelector : isPointsBasedGradingScaleGroup ? lowValueSelector : percentLowSelector;
            var highSelector = isStandardsGradingScaleGroup ? pointsHighSelector : isPointsBasedGradingScaleGroup ? highValueSelector : percentHighSelector;
            var defaultCalculationSelector = isStandardsGradingScaleGroup || isPointsBasedGradingScaleGroup ? defaultCalculationValueSelector : defaultCalculationPercentSelector;

            var highInputSelector = isStandardsGradingScaleGroup || isPointsBasedGradingScaleGroup ? '.highgradingscale' : '.highgradingscalepercents';
            var lowInputSelector = isStandardsGradingScaleGroup || isPointsBasedGradingScaleGroup ? '.lowgradingscale' : '.lowgradingscalepercents';
            var defaultCalculationInputSelector = isStandardsGradingScaleGroup || isPointsBasedGradingScaleGroup ? '.defaultcalculationvaluegradingscale' : '.defaultcalculationpercentgradingscalepercents';
            var selectSelector = isStandardsGradingScaleGroup || isPointsBasedGradingScaleGroup ? '.selectpointsgradingscalegroupgrademarks' : '.selectgradingscalegroupgrademarks';

            if (!gradingScaleBrowses.hasOwnProperty(browseID) || !isPaging)
            {
                gradingScaleBrowses[browseID] =
                {
                    gradeMarks: {},
                    maxRow: function()
                    {
                        var max = 0;

                        for (var prop in gradingScaleBrowses[browseID].gradeMarks)
                        {
                            if (!gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(prop))
                            {
                                continue;
                            }

                            var numericValue = parseInt(prop);

                            if (numericValue > max)
                            {
                                max = numericValue;
                            }
                        }

                        return max;
                    }
                };
            }

            var getHighElement = function (row)
            {
                var highElements = browse.find(highSelector);
                return highElements.filter("[id$='High-" + row + "']").add(highElements.filter("[id$='High-" + row + "-Workflow']"));
            };

            var getLowElement = function (row)
            {
                var lowElements = browse.find(lowSelector);
                return lowElements.filter("[id$='Low-" + row + "']").add(lowElements.filter("[id$='Low-" + row + "-Workflow']"));
            };

            var getDefaultCalculationElement = function (row)
            {
                var defaultCalculationElements = browse.find(defaultCalculationSelector);
                return defaultCalculationElements.filter("[id*='DefaultCalculation'][id$='-" + row + "']").add(defaultCalculationElements.filter("[id*='DefaultCalculation'][id$='-" + row + "-Workflow']"));
            };

            var getAllowSubjectiveElement = function (row)
            {
                var suffix = isPointsBasedGradingScaleGroup ? "Points" : "Percent";
                var allowSubjectiveElements = browse.find(defaultAllowSubjectiveSelector);
                return allowSubjectiveElements.filter("[id$='AllowSubjective-" + row + "']").add(allowSubjectiveElements.filter("[id$='AllowSubjective-" + row + "-Workflow-" + suffix +"']"));
            }

            var getOffsetValue = function (value, isAdd)
            {
                var offsetValue;

                if (isAdd)
                {
                    offsetValue = (Math.round(value * 100) + Math.round(offset * 100)) / 100;
                }
                else
                {
                    offsetValue = (Math.round(value * 100) - Math.round(offset * 100)) / 100;
                }

                if (isNaN(offsetValue))
                {
                    return undefined;
                }

                return offsetValue;
            };

            var setDefaultCalculationValue = function (row, element)
            {
                var value = skyward.controls.getValue(element);
                var offsetValue = getOffsetValue(parseFloat(value), true);

                row = parseInt(row);

                if (offsetValue == undefined)
                {
                    return;
                }

                if (gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(row))
                {
                    var defaultCalculationInput = getDefaultCalculationElement(row);
                    var lowInput = getLowElement(row);
                    var highInput = getHighElement(row);

                    if (defaultCalculationInput.length > 0)
                    {
                        var updateCalculationInputFromLow = parseFloat(skyward.controls.getValue(lowInput)) > parseFloat(skyward.controls.getValue(defaultCalculationInput));
                        var updateCalculationInputFromHigh = parseFloat(skyward.controls.getValue(highInput)) < parseFloat(skyward.controls.getValue(defaultCalculationInput));

                        if ((lowInput.length > 0 && updateCalculationInputFromLow) || (highInput.length > 0 && updateCalculationInputFromHigh))
                        {
                            skyward.controls.setValue(defaultCalculationInput, value);
                            processGradeMark(row, undefined, undefined, defaultCalculationInput, true);
                        }

                        if (lowInput.length > 0 && parseFloat(value) <= parseFloat(skyward.controls.getValue(lowInput)))
                        {
                            skyward.controls.setValue(lowInput, value);
                            processGradeMark(row, undefined, lowInput, undefined, true);

                            setRangeValues(row, lowInput, true);
                            setPreviousOrNextDefaultCalculationValue(row, lowInput, false);
                            return;
                        }

                        if (highInput.length > 0 && parseFloat(value) >= parseFloat(skyward.controls.getValue(highInput)))
                        {
                            skyward.controls.setValue(highInput, value);
                            processGradeMark(row, highInput, undefined, undefined, true);

                            setRangeValues(row, highInput, false);
                            setPreviousOrNextDefaultCalculationValue(row, highInput, true);
                            return;
                        }
                    }

                    gradingScaleBrowses[browseID].gradeMarks[row].defaultCalculationValue = offsetValue;
                    gradingScaleBrowses[browseID].gradeMarks[row].defaultCalculationNeedsUpdating = true;
                    return;
                }
            };

            var setPreviousLowValue = function (row, element)
            {
                var value = skyward.controls.getValue(element);
                var offsetValue = getOffsetValue(parseFloat(value), true);

                row = parseInt(row);

                if (offsetValue == undefined)
                {
                    return;
                }

                for (var i = row - 1; i > 0; i--)
                {
                    if (gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(i))
                    {
                        var lowInput = getLowElement(i);

                        if (lowInput.length > 0)
                        {
                            skyward.controls.setValue(lowInput, offsetValue);
                            processGradeMark(i, undefined, lowInput, undefined, true);
                        }
                        else
                        {
                            gradingScaleBrowses[browseID].gradeMarks[i].lowValue = offsetValue;
                            gradingScaleBrowses[browseID].gradeMarks[i].lowNeedsUpdating = true;
                        }
                        return;
                    }
                }
            };

            var setNextHighValue = function (row, element)
            {
                var value = skyward.controls.getValue(element);
                var offsetValue = getOffsetValue(parseFloat(value), false);

                row = parseInt(row);

                if (offsetValue == undefined)
                {
                    return;
                }

                for (var i = row + 1; i <= gradingScaleBrowses[browseID].maxRow(); i++)
                {
                    if (gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(i))
                    {
                        var highInput = getHighElement(i);

                        if (highInput.length > 0)
                        {
                            skyward.controls.setValue(highInput, offsetValue);
                            processGradeMark(i, highInput, undefined, undefined, true);
                        }
                        else
                        {
                            gradingScaleBrowses[browseID].gradeMarks[i].highValue = offsetValue;
                            gradingScaleBrowses[browseID].gradeMarks[i].highNeedsUpdating = true;
                        }
                        return;
                    }
                }
            };

            var setRangeValues = function (row, element, isAdd) {
                var value = skyward.controls.getValue(element);
                var offsetValue = getOffsetValue(parseFloat(value), isAdd);

                row = parseInt(row);

                if (offsetValue == undefined) {
                    return;
                }

                if (gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(row)) {
                    var rangeInput = isAdd ? getHighElement(row) : getLowElement(row);
                    var rangeValue = parseFloat(skyward.controls.getValue(rangeInput));

                    var updateRangePercent = (isAdd && rangeValue <= value) || (!isAdd && rangeValue >= value);

                    if (rangeInput.length > 0 && updateRangePercent) {
                        skyward.controls.setValue(rangeInput, offsetValue);
                        isAdd ? processGradeMark(row, rangeInput, undefined, undefined, true) : processGradeMark(row, undefined, rangeInput, undefined, true);
                    }

                    isAdd ? setNextHighValue(row, element) : setPreviousLowValue(row, element);
                }
            };

            var setPreviousOrNextDefaultCalculationValue = function (row, element, isAdd) {
                var value = skyward.controls.getValue(element);
                var offsetValue = getOffsetValue(parseFloat(value), isAdd);

                row = parseInt(row);

                if (offsetValue == undefined) {
                    return;
                }

                for (var i = isAdd ? row - 1 : row + 1; (i > 0 && isAdd) || (i <= gradingScaleBrowses[browseID].maxRow() && !isAdd); isAdd ? i-- : i++) {
                    if (gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(i))
                    {
                        var defaultCalculationInput = getDefaultCalculationElement(i);
                        var defaultCalculationValue = parseFloat(skyward.controls.getValue(defaultCalculationInput));

                        var updateDefaultPercent = (isAdd && defaultCalculationValue <= value) || (!isAdd && defaultCalculationValue >= value);

                        if (defaultCalculationInput.length > 0 && updateDefaultPercent)
                        {
                            skyward.controls.setValue(defaultCalculationInput, offsetValue);
                            processGradeMark(i, undefined, undefined, defaultCalculationInput, true);

                            return;
                        }
                    }
                }
            };

            var processGradeMark = function (row, highInput, lowInput, defaultCalculationInput, isChecked)
            {
                if (!isChecked)
                {
                    if (gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(row))
                    {
                        delete gradingScaleBrowses[browseID].gradeMarks[row];
                    }
                    return;
                }

                if (!gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(row))
                {
                    gradingScaleBrowses[browseID].gradeMarks[row] = {};
                }

                var highValue = skyward.controls.getValue(highInput);
                var lowValue = skyward.controls.getValue(lowInput);
                var defaultCalculationValue = skyward.controls.getValue(defaultCalculationInput);

                if (!isNaN(highValue))
                {
                    gradingScaleBrowses[browseID].gradeMarks[row].highValue = highValue;
                }
                if (!isNaN(lowValue))
                {
                    gradingScaleBrowses[browseID].gradeMarks[row].lowValue = lowValue;
                }
                if (!isNaN(defaultCalculationValue)) {
                    gradingScaleBrowses[browseID].gradeMarks[row].defaultCalculationValue = defaultCalculationValue;
                }
            };

            var resetFields = function (element)
            {
                var row = element.data().row;

                var highInput = getHighElement(row);
                var lowInput = getLowElement(row);
                var defaultCalculationInput = getDefaultCalculationElement(row);
                var allowSubjectiveInput = getAllowSubjectiveElement(row);
                var isChecked = element.is(':checked');

                if (isChecked)
                {
                    skyward.controls.setValue(highInput, defaultValue);
                    skyward.controls.setValue(lowInput, defaultValue);
                    skyward.controls.setValue(defaultCalculationInput, defaultValue);
                }
                else
                {
                    skyward.controls.setValue(highInput, disabledValue);
                    skyward.controls.setValue(lowInput, disabledValue);
                    skyward.controls.setValue(defaultCalculationInput, disabledValue);
                    skyward.controls.setValue(allowSubjectiveInput, disabledValue);
                }

                if (isStandardsGradingScaleGroup || isPointsBasedGradingScaleGroup)
                {
                    var colorField = browse.find(colorPrefix + row);
                    if (isChecked)
                    {
                        colorField.spectrum('set', '#63BE7B'); // Default to green
                        colorField.change();
                    }
                    else
                    {
                        colorField.spectrum('set', '');
                        colorField.change();
                    }
                }

                processGradeMark(row, highInput, lowInput, defaultCalculationInput, isChecked);
            };

            var resetFieldsForSubjective = function (element) {
                var row = element.data().row;

                var highInput = getHighElement(row);
                var lowInput = getLowElement(row);
                var defaultCalculationInput = getDefaultCalculationElement(row);
                var allowSubjectiveInput = getAllowSubjectiveElement(row);
                var isChecked = element.is(':checked');
                var allowEmptyBox = allowSubjectiveInput.is(":checked");

                var highInputValue = skyward.controls.getValue(highInput);
                var lowInputValue = skyward.controls.getValue(lowInput);
                var defaultCalculationInputValue = skyward.controls.getValue(defaultCalculationInput);

                if (isChecked)
                {
                    var valueToSet = allowEmptyBox ? '' : defaultValue;

                    if (highInputValue == null || highInputValue == '' || highInputValue == defaultValue)
                    {
                        skyward.controls.setValue(highInput, valueToSet);
                    }

                    if (lowInputValue == null || lowInputValue == '' || (lowInputValue == defaultValue && highInputValue == defaultValue && defaultCalculationInputValue == defaultValue))
                    {
                        skyward.controls.setValue(lowInput, valueToSet);
                    }

                    if (defaultCalculationInputValue == null || defaultCalculationInputValue == '' || (defaultCalculationInputValue == defaultValue && highInputValue == defaultValue && lowInputValue == defaultValue))
                    {
                        skyward.controls.setValue(defaultCalculationInput, valueToSet);
                    }
                }
                else
                {
                    if (highInputValue == null || highInputValue == '')
                    {
                        skyward.controls.setValue(highInput, defaultValue);
                    }

                    if (lowInputValue == null || lowInputValue == '')
                    {
                        skyward.controls.setValue(lowInput, defaultValue);
                    }

                    if (defaultCalculationInputValue == null || defaultCalculationInputValue == '')
                    {
                        skyward.controls.setValue(defaultCalculationInput, defaultValue);
                    }
                }
            };

            var processHighInputBlur = function (event)
            {
                var elementID = event.target.id;
                var element = browse.find('#' + elementID);
                var numericValue = parseFloat(skyward.controls.getValue(element));

                if (numericValue == 0 || element.is('[readonly]'))
                {
                    return;
                }

                var idParts = elementID.split('-');
                var row = idParts[1];
                processGradeMark(row, element, undefined, undefined, true);
                setRangeValues(row, element, false);
                setDefaultCalculationValue(row, element);

                var rowElement = element.parents("tr").first();
                var allowSubjectiveElement = rowElement.find(defaultAllowSubjectiveSelector).first();
                if (allowSubjectiveElement && allowSubjectiveElement.is(":checked") && !isNaN(numericValue))
                {
                    defaultInputValueIfNotSet(rowElement, lowInputSelector, defaultValue);
                    defaultInputValueIfNotSet(rowElement, defaultCalculationInputSelector, defaultValue);
                }
            };

            var processLowInputBlur = function (event)
            {
                var elementID = event.target.id;
                var element = browse.find('#' + elementID);
                var numericValue = parseFloat(skyward.controls.getValue(element));

                if (numericValue == 0 || element.is('[readonly]'))
                {
                    return;
                }

                var idParts = elementID.split('-');
                var row = idParts[1];
                processGradeMark(row, undefined, element, undefined, true);
                setRangeValues(row, element, true);
                setDefaultCalculationValue(row, element);

                var rowElement = element.parents("tr").first();
                var allowSubjectiveElement = rowElement.find(defaultAllowSubjectiveSelector).first();
                if (allowSubjectiveElement && allowSubjectiveElement.is(":checked") && !isNaN(numericValue))
                {
                    defaultInputValueIfNotSet(rowElement, highInputSelector, defaultValue);
                    defaultInputValueIfNotSet(rowElement, defaultCalculationInputSelector, defaultValue);
                }
            };

            var defaultInputValueIfNotSet = function (rowElement, affectedElementSelector, defaultValue)
            {
                var elementValue = skyward.controls.getValue(rowElement.find(affectedElementSelector));
                if (elementValue == null || elementValue == "")
                {
                    skyward.controls.setValue(rowElement.find(affectedElementSelector), defaultValue);
                }
            };

            var processDefaultCalculationInputBlur = function (event)
            {
                var elementID = event.target.id;
                var element = browse.find('#' + elementID);
                var numericValue = parseFloat(skyward.controls.getValue(element));

                if (numericValue == 0 || element.is('[readonly]'))
                {
                    return;
                }

                var idParts = elementID.split('-');
                var row = idParts[1];
                processGradeMark(row, undefined, undefined, element, true);
                setDefaultCalculationValue(row, element);
            };

            browse.on('change', selectSelector, function () { resetFields($(this)); });
            browse.on('change', ".selectgradingscalegroupgrademarkallowsubjective", function () { resetFieldsForSubjective($(this)); });
            browse.on('blur', highInputSelector, processHighInputBlur);
            browse.on('blur', lowInputSelector, processLowInputBlur);
            browse.on('blur', defaultCalculationInputSelector, processDefaultCalculationInputBlur);

            browse.find(highInputSelector).each(function ()
            {
                var highInput = $(this);

                var idParts = highInput.attr('id').split('-');
                var row = idParts[1];

                var lowInput = getLowElement(row);
                var defaultCalculationInput = getDefaultCalculationElement(row);

                if (!gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(row))
                {
                    var value = skyward.controls.getValue(highInput);
                    var validValue = !isNaN(value) && value != '' && !highInput.is('[readonly]') && !lowInput.is('[readonly]') && !defaultCalculationInput.is('[readonly]');
                    processGradeMark(row, highInput, lowInput, defaultCalculationInput, validValue);
                }
            });

            for (var key in gradingScaleBrowses[browseID].gradeMarks)
            {
                if (!gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(key))
                {
                    continue;
                }

                var gradeMark = gradingScaleBrowses[browseID].gradeMarks[key];

                if (gradeMark.hasOwnProperty('highNeedsUpdating') && gradeMark.highNeedsUpdating)
                {
                    var highElement = getHighElement(key);
                    skyward.controls.setValue(highElement, gradeMark.highValue);
                    gradeMark.highNeedsUpdating = false;
                }

                if (gradeMark.hasOwnProperty('lowNeedsUpdating') && gradeMark.lowNeedsUpdating)
                {
                    var lowElement = getLowElement(key);
                    skyward.controls.setValue(lowElement, gradeMark.lowValue);
                    gradeMark.lowNeedsUpdating = false;
                }

                if (gradeMark.hasOwnProperty('defaultCalculationNeedsUpdating') && gradeMark.defaultCalculationNeedsUpdating)
                {
                    var defaultCalculationElement = getDefaultCalculationElement(key);
                    skyward.controls.setValue(defaultCalculationElement, gradeMark.defaultCalculationValue);
                    gradeMark.lowNeedsUpdating = false;
                }
            }
        };



        var init = function (selector)
        {
            var element = $(selector);
            var isPaging = element.hasClass('editablebrowse');

            var percentLow = element.find(percentLowSelector);
            var pointsLow = element.find(pointsLowSelector);
            var lowValue = element.find(lowValueSelector);

            var isStandardsGradingScaleGroup = false;
            var isPointsBasedGradingScaleGroup = false;

            var browse = undefined;
            if (pointsLow.length > 0)
            {
                browse = pointsLow.closest('.editablebrowse');
                isPointsBasedGradingScaleGroup = false;
                isStandardsGradingScaleGroup = true;
            }
            if (percentLow.length > 0)
            {
                browse = percentLow.closest('.editablebrowse');
                isPointsBasedGradingScaleGroup = false;
                isStandardsGradingScaleGroup = false;
            }

            if (browse && browse.length == 1)
            {
                processGradeMarkBrowse(browse, isStandardsGradingScaleGroup, isPointsBasedGradingScaleGroup, isPaging);
            }

            if (lowValue.length > 0)
            {
                browse = lowValue.closest('.editablebrowse');
                isStandardsGradingScaleGroup = false;
                isPointsBasedGradingScaleGroup = true;
                if (browse && browse.length == 1)
                {
                    processGradeMarkBrowse(browse, isStandardsGradingScaleGroup, isPointsBasedGradingScaleGroup, isPaging);
                }
            }

            var updateGradingScalePreviewWorkflow = function ()
            {
                var postData = {};
                var element = $(this);

                postData["GradingScaleGroupID"] = $(element.children()[0]).val();

                $.ajax(
                {
                    url: skyward.global.virtualDir + "GradeBook/GradingScaleGroup/UpdateGradingScalePreviewWorkflow",
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    success: function (data)
                    {
                        var previewDiv = $("[id*=GradingScaleGroupPreviewWorkflow]");
                        var divHtml = data.Update["GradingScaleGroupPreviewWorkflow"];
                        previewDiv.html(divHtml);
                    }
                });
            }
            var updateGradingScalePreview = function ()
            {
                var postData = {};
                var element = $(this);

                postData["GradingScaleGroupID"] = $(element.children()[0]).val();

                $.ajax(
                {
                    url: skyward.global.virtualDir + "GradeBook/GradingScaleGroup/UpdateGradingScalePreviewDetails",
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    success: async function (data)
                    {
                        var previewDiv = $("[id*=GradingScaleGroupPreview]");
                        var divHtml = data.Update["GradingScaleGroupPreview"];
                        await previewDiv.viewpartHtml(divHtml);
                    }
                });
            }

            var gradingScalePreviewDiv = $(".gradingScaleGroupEELWithPreview .codeEEL");
            gradingScalePreviewDiv.off("eelComplete");
            gradingScalePreviewDiv.on("eelComplete", updateGradingScalePreview);

            gradingScalePreviewDiv = $(".gradingScaleGroupEELWithPreview_Workflow .codeEEL");
            gradingScalePreviewDiv.off("eelComplete");
            gradingScalePreviewDiv.on("eelComplete", updateGradingScalePreviewWorkflow);
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);